export const admitCardApi = {
    heading:[
        {
            head:"Name"
        },
        {
            head:"Student ID"
        },
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Room No."
        },
        {
            head:"Floor No."
        },
        
      
    ],
    data:[
       {
        
        name:"Manik",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
       {
        
        name:"Morning",
        studentID:1545,
        class:"class 7",
        section:"Diamond 1",
        roomno:"4", 
        floorno:"2",
       
    },
      
     
       
    ]
}